import { Cursor } from "./cursor";
import {ISettings, Renderer} from "./renderer";
import { ActionFactory } from "./actionFactory";
import {Network, NetworkData} from "./network";
import assert from "assert";
import {dispatchData} from "./dispatcher";

export class FSTN {
    protected actionFactory?: ActionFactory;
    protected cursor?: Cursor;
    protected network?: Network;
    protected renderer: Renderer;
    protected paused: boolean = false;
    protected stepping: boolean = false;

    private _initialised = false;

    constructor(settings: ISettings) {
        this.renderer = new Renderer(settings);
    }

    public initialise(network: NetworkData, actionFactory: ActionFactory): Promise<void> {
        this.paused = true;
        return this.renderer.initialise().then(()=> {
            this.actionFactory = actionFactory;
            this.network = new Network(network);
            this.cursor = new Cursor(this.network, this.actionFactory);
            this.renderer.setCursor(this.cursor);
            this._initialised = true;
        });
    }

    public get initialised() {
        return this._initialised;
    }
    public getActionFactory(): ActionFactory
    {
        assert(this.actionFactory);
        return this.actionFactory;
    }

    public getCursor(): Cursor
    {
        assert(this.cursor);
        return this.cursor;
    }

    public getRenderer(): Renderer
    {
        assert(this.renderer);
        return this.renderer;
    }
    protected updateDebug(): void
    {
        if (this.cursor && this.network) {
            const state = this.network.states.get(this.cursor.state);

            dispatchData("FSTN Network State",
                {
                    state: `${this.cursor.name} - ${this.cursor.state}`,
                    triggers: this.cursor.triggers.join(", "),
                    actions: this.cursor.actions.map((action) => action.action).join(", "),
                    destinations: state?.transitions.map(transition => {
                        return `${transition.destination}: ${transition.trigger}`;
                    }).join(", "),
                    registers: Array.from(this.cursor.registers).reduce((obj: any, [key, value]) => {
                        obj[key] = value.get();
                        return obj;
                    }, {})
                });
        }
    }
    public isMuted(): boolean
    {
        return this.renderer.isMuted();
    }
    public mute(): void
    {
        this.renderer.mute();
    }
    public unmute(): void
    {
        this.renderer.unmute();
    }
    public reload(network: Network): void
    {
        this.getCursor().reload(network);
    }
    public restart(): Promise<void>
    {
        return this.renderer.initialise();
    }
}